import getIdReduxUtil from 'modules/redux/utils/get-id'

function createPointerReduxUtil (instance) {
  return {
    className: instance.className,
    data: {
      id: getIdReduxUtil(instance)
    }
  }
}

export default createPointerReduxUtil
